<label
    class="agpr-numberInput"
    [class.agpr-numberInput--spaced]="bottomMargin"
>
    <div *ngIf="label || required" class="agpr-numberInput-label">
        {{ label | localize }}
        <span *ngIf="required" class="agpr-numberInput-required">*</span>
        <span
            *ngIf="tooltip"
            class="agpr-numberInput-tooltip fa-regular fa-circle-info"
            [pTooltip]="tooltip | localize"
        ></span>
    </div>
</label>
<div class="agpr-numberInput-container">
    <div class="agpr-numberInput-inputWrapper">
        <input
            #input
            [id]="id"
            type="tel"
            class="agpr-numberInput-input"
            [disabled]="disabled"
            [(ngModel)]="value"
            (ngModelChange)="computeChanges()"
            (countrychange)="computeChanges()"
            (blur)="onBlur($event)"
            (focus)="focus.emit($event)"
            (keydown)="onKeydown($event)"
            (keyup)="onKeyUp($event)"
            [maxlength]="maxLength"
            [readOnly]="readOnly"

        />
    </div>
</div>

